module.exports = __webpack_public_path__ + "static/media/b1.f3aa99b2.jpg";